<template>
    <div class="report-builder-list mt-3">
        <div v-if="isLoading" class="text-center py-4">
            <div class="spinner-border text-primary" role="status">
                <span class="visually-hidden">Loading...</span>
            </div>
        </div>
        <div v-else>
            <div class="card mb-3 table-card" v-if="local_report_pages && local_report_pages.length > 0">
                <div class="card-header">
                    <div class="row">
                        <div class="col-lg-4 col-12">
                            <h3 class="mt-2">Reports ({{ local_report_pages.length }})</h3>
                        </div>
                        <div class="col-lg-8 d-none d-lg-block">
                            <div class="d-flex justify-content-end justify-self-end gap-2">
                                <accordion-select 
                                    v-model="selectedClientOption"
                                    :options="clientOptions"
                                    @update:modelValue="handleClientSelectionChange"
                                    class="d-inline-block client-select"
                                />

                                <a v-if="local_client_id === '' && local_report_pages.length > 0" class="btn btn-primary" :href="'/admin/report_builder/template/null/new'">
                                    <i class="fa fas fa-fw fa-plus"></i> Create a Report
                                </a>
                                <a v-if="local_client_id !== '' && local_report_pages.length > 0" class="btn btn-primary" :href="'/admin/report_builder/client_specific/' + (local_client?.url || '') + '/new'">
                                    <i class="fa fas fa-fw fa-plus"></i> Create a Report
                                </a>

                                <a v-if="local_client_id !== '' && local_report_pages.length > 0 && local_blends.length <= 1" class="btn btn-secondary" data-bs-toggle="modal" data-bs-target="#dimension-filter-modal">
                                    <i class="fa fas fa-fw fa-plus"></i> Add Custom Filter
                                </a>
                                <div v-else-if="local_client_id !== '' && local_report_pages.length > 0 && local_blends.length > 1" class="dropdown">
                                    <button class="btn btn-secondary dropdown-toggle" type="button" id="dropdownMenuButton" data-bs-toggle="dropdown" aria-expanded="false">
                                        <i class="fa fas fa-fw fa-plus"></i> Add Custom Filter
                                    </button>
                                    <ul class="dropdown-menu dropdown-menu-primary" aria-labelledby="dropdownMenuButton">
                                        <li v-for="blend in local_blends" :key="blend.id">
                                            <a class="dropdown-item" href="#" data-bs-toggle="modal" data-bs-target="#dimension-filter-modal" @click.prevent="selected_blend = blend">{{ propercase(blend.type) }}</a>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="card-body p-0">
                    <table class="table table-with-pagination mb-0">
                        <thead>
                            <tr class="table-header-row">
                                <th @click="sortByKey('name')" class="d-table-cell">
                                    <div class="d-flex flex-row">
                                        Report Name
                                        <div class="d-flex flex-column">
                                            <img class="sort-key" src="/img/icons/avid-icons/chevron-up.svg" :class="{ 'sort-key-active': sort_key === 'name' && sort_order === 'asc' }" alt="">
                                            <img class="sort-key" src="/img/icons/avid-icons/chevron-down.svg" :class="{ 'sort-key-active': sort_key === 'name' && sort_order === 'des' }" alt="">
                                        </div>
                                    </div>
                                </th>
                                <th class="d-table-cell column-sort-disabled">
                                    <div class="d-flex flex-row">
                                        Status
                                    </div>
                                </th>
                                <th @click="sortByKey('group_name')" class="d-table-cell">
                                    <div class="d-flex flex-row">
                                        Group Name
                                        <div class="d-flex flex-column">
                                            <img class="sort-key" src="/img/icons/avid-icons/chevron-up.svg" :class="{ 'sort-key-active': sort_key === 'group_name' && sort_order === 'asc' }" alt="">
                                            <img class="sort-key" src="/img/icons/avid-icons/chevron-down.svg" :class="{ 'sort-key-active': sort_key === 'group_name' && sort_order === 'des' }" alt="">
                                        </div>
                                    </div>
                                </th>
                                <th @click="sortByKey('data_blend_type')" class="d-none d-sm-table-cell">
                                    <div class="d-flex flex-row">
                                        Data Blend Type
                                        <div class="d-flex flex-column">
                                            <img class="sort-key" src="/img/icons/avid-icons/chevron-up.svg" :class="{ 'sort-key-active': sort_key === 'data_blend_type' && sort_order === 'asc' }" alt="">
                                            <img class="sort-key" src="/img/icons/avid-icons/chevron-down.svg" :class="{ 'sort-key-active': sort_key === 'data_blend_type' && sort_order === 'des' }" alt="">
                                        </div>
                                    </div>
                                </th>
                                <th @click="sortByKey('updated_at')" class="d-none d-sm-table-cell">
                                    <div class="d-flex flex-row">
                                        Last Updated At
                                        <div class="d-flex flex-column">
                                            <img class="sort-key" src="/img/icons/avid-icons/chevron-up.svg" :class="{ 'sort-key-active': sort_key === 'updated_at' && sort_order === 'asc' }" alt="">
                                            <img class="sort-key" src="/img/icons/avid-icons/chevron-down.svg" :class="{ 'sort-key-active': sort_key === 'updated_at' && sort_order === 'des' }" alt="">
                                        </div>
                                    </div>
                                </th>
                                <th @click="sortByKey('deployed_at')" v-if="local_client_id === ''" class="d-none d-sm-table-cell">
                                    <div class="d-flex flex-row">
                                        Last Deployed At
                                        <div class="d-flex flex-column">
                                            <img class="sort-key" src="/img/icons/avid-icons/chevron-up.svg" :class="{ 'sort-key-active': sort_key === 'deployed_at' && sort_order === 'asc' }" alt="">
                                            <img class="sort-key" src="/img/icons/avid-icons/chevron-down.svg" :class="{ 'sort-key-active': sort_key === 'deployed_at' && sort_order === 'des' }" alt="">
                                        </div>
                                    </div>
                                </th>
                                <th class="column-sort-disabled d-none d-sm-table-cell pe-3" width="1">
                                    <div class="d-flex flex-row">
                                        Actions
                                    </div>
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(page, index) in list_shown" :key="page.id">
                                <td class="d-table-cell align-start">
                                    <a :href="'/admin/report_builder/' + page.url">{{ page.name }}</a>
                                </td>
                                <td class="d-table-cell">
                                    <div class="badge" :class="{
                                        'badge-secondary': page.status === 'archived',
                                        'bg-green bg-icon-success': page.status === 'active',
                                        'badge-primary': page.status === 'draft'
                                    }">{{ propercase(page.status) }}</div>
                                </td>
                                <td class="d-table-cell">
                                    {{ page.group_name }}
                                </td>
                                <td class="d-none d-sm-table-cell">
                                    {{ propercase(page.data_blend_type) }}
                                </td>
                                <td class="d-none d-sm-table-cell">
                                    {{ datetime(page.updated_at) }}
                                </td>
                                <td class="d-none d-sm-table-cell" v-if="local_client_id === ''">
                                    {{ datetime(page.deployed_at) }}
                                </td>
                                <td class="d-none d-sm-table-cell text-end">
                                    <div class="dropdown d-flex justify-content-center">
                                        <button class="btn btn-white btn-icon-only-md" data-bs-toggle="dropdown" data-bs-auto-close="true" aria-expanded="false" aria-label="Button">
                                            <img class="icon" src="/img/icons/avid-icons/dots-vertical.svg" data-bs-toggle="tooltip" title="Actions" alt="">
                                        </button>
                                        <div class="dropdown-menu dropdown-menu-primary dropdown-menu-end">
                                            <a v-if="page.is_template" href="#" class="dropdown-item" @click.prevent="deployTemplate(page.id)">
                                                <img class="icon me-2" src="/img/icons/avid-icons/rocket-02.svg" alt=""> Deploy Report
                                            </a>
                                            <a href="#" class="dropdown-item" @click.prevent="copyReport(page.id)">
                                                <img class="icon me-2" src="/img/icons/avid-icons/document-copy.svg" alt=""> Copy Report
                                            </a>
                                            <a v-if="page.is_template === false" href="#" class="dropdown-item" @click.prevent="navigateToReport(page)">
                                                <img class="icon me-2" src="/img/icons/avid-icons/arrow-up-right.svg" alt=""> View Live Report
                                            </a>
                                            <hr class="my-1">
                                            <a class="dropdown-item text-danger" href="#" @click.prevent="deleteReport(page.id)">
                                                <img class="icon red-icon me-2" src="/img/icons/avid-icons/trash.svg" alt=""> Delete Report
                                            </a>
                                        </div>
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                        <tfoot class="table-border-bottom-0">
                            <tr>
                                <td colspan="100%" class="py-0">
                                    <div class="table-pagination">
                                        <div class="table-pagination--group d-none d-md-flex">
                                            <div class="position-relative">
                                                <select class="form-select" v-model="num_per_page" @change="reloadPagination(local_report_pages)" aria-label="Num Per Page">
                                                    <option value="5000">ALL</option>
                                                    <option v-for="num in num_per_page_options" :key="num" :value="num">{{ num }}</option>
                                                </select>
                                                <div class="select-display-text">
                                                    Showing {{ num_per_page === '5000' ? 'ALL' : num_per_page }}
                                                </div>
                                            </div>
                                        </div>

                                        <div class="table-pagination--group d-none d-lg-flex">
                                            {{ local_report_pages.length === 0 ? '0' : item_interval }} of {{ local_report_pages.length }}
                                        </div>

                                        <div class="table-pagination--group">
                                            <button v-if="page_count > 1" class="btn btn-secondary btn-icon-only-md me-1" @click="moveToPrevPage(local_report_pages)" :disabled="page_index === 0" data-bs-toggle="tooltip" title="Previous page">
                                                <img class="icon" src="/img/icons/avid-icons/chevron-left.svg" alt="">
                                            </button>

                                            <div class="d-flex page-selector" v-if="page_index_array.length <= 3">
                                                <button v-for="page in page_index_array" :key="page" class="btn btn-none btn-icon-only-md" :class="{ 'current-page': page === (page_index + 1) }" @click="moveToPage(page, local_report_pages)">
                                                    {{ page }}
                                                </button>
                                            </div>
                                            <div class="d-flex page-selector" v-else>
                                                <button v-for="page in page_index_array.slice(0,2)" :key="page" class="btn btn-none btn-icon-only-md" :class="{ 'current-page': page === (page_index + 1) }" @click="moveToPage(page, local_report_pages)">
                                                    {{ page }}
                                                </button>

                                                <button v-if="page_index > 2" class="btn btn-none btn-icon-only-md text-nowrap" disabled>
                                                ...
                                                </button>
                                                <button v-if="page_index >= 2 && page_index < page_index_array.length -1" class="btn btn-none btn-icon-only-md current-page">
                                                    {{ page_index + 1 }}
                                                </button>

                                                <button v-if="page_index < page_index_array.length -2" class="btn btn-none btn-icon-only-md text-nowrap" disabled aria-hidden="true">
                                                ...
                                                </button>
                                                <button :class="{ 'current-page': page_index === (page_index_array.length -1) }" class="btn btn-none btn-icon-only-md" @click="moveToPage(page_index_array.length, local_report_pages)" :key="page_index_array.length">
                                                    {{ page_index_array.length }}
                                                </button>
                                            </div>

                                            <button v-if="page_count > 1" class="btn btn-secondary btn-icon-only-md ms-1" @click="moveToNextPage(local_report_pages)" :disabled="page_index === page_count -1" data-bs-toggle="tooltip" title="Next page">
                                                <img class="icon" src="/img/icons/avid-icons/chevron-right.svg" alt="">
                                            </button>
                                        </div>
                                    </div>
                                </td>
                            </tr>
                        </tfoot>
                    </table>
                </div>
            </div>

            <div v-else>
                <div class="card mb-3">
                    <div class="card-body mt-3 text-center">
                        <h2 class="text-center">No reports have been created yet.</h2>
                        <a v-if="local_client_id === ''" class="btn btn-primary mb-3" :href="'/admin/report_builder/template/null/new'">
                            <i class="fa fas fa-fw fa-plus"></i> Create a Report
                        </a>
                        <a v-if="local_client_id !== ''" class="btn btn-primary mb-3" :href="'/admin/report_builder/client_specific/' + (local_client?.url || '') + '/new'">
                            <i class="fa fas fa-fw fa-plus"></i> Create a Report
                        </a>
                    </div>
                </div>
            </div>
            <div class="modal fade" id="dimension-filter-modal"
                aria-labelledby="dimension-filter-modal" data-bs-backdrop="static" aria-hidden="true">
                <report-builder-udf-popup :client_id="local_client_id" :data_blend="selected_blend" @updateFilterWithinGroup="addFilter" :show_group_name="true"></report-builder-udf-popup>
            </div>
        </div>
    </div>
</template>

<script>
import { defineComponent } from 'vue';
import Swal from 'sweetalert2';
import { useNotifications } from '../../../composables/useNotifications';
import tablePaginationMixin from '../../../mixins/table_pagination';
import AccordionSelect from '../../components/AccordionSelect.vue';

export default defineComponent({
    name: 'ReportBuilderList',
    components: {
        Swal,
        AccordionSelect
    },
    setup() {
        const { showNotification } = useNotifications();
        return {
            showNotification
        };
    },
    props: {
        report_pages: {
            type: Array,
            required: true
        },
        clients: {
            type: Object,
            required: true
        }
    },
    mixins: [tablePaginationMixin],
    data() {
        return {
            source_pages: [],
            local_report_pages: [],
            local_blends: [],
            selected_blend: null,
            local_client_id: "",
            local_client: {},
            selectedClientOption: null,
            list_shown: [],
            sort_key: 'name',
            sort_order: 'asc',
            isLoading: false,
        };
    },
    computed: {
        clientOptions() {
            const options = [
                {
                    value: "",
                    text: "*** Template Reports ***"
                }
            ];
            
            // Add client options
            Object.values(this.clients).forEach(client => {
                options.push({
                    value: client.id,
                    text: `${client.name} Reports`
                });
            });
            
            return options;
        }
    },
    beforeMount() {
        //Clone the report_pages object
        this.local_report_pages = JSON.parse(JSON.stringify(this.report_pages));
        this.source_pages = JSON.parse(JSON.stringify(this.report_pages));
        const params = new URLSearchParams(window.location.search);
        //If the URL containst the word list, get the last part of the URL and set it as the client
        if(window.location.href.includes('list')){
            const url = window.location.href;
            const client_id = url.substring(url.lastIndexOf('/') + 1);
            this.local_client = Object.values(this.clients).find(c => c.id === client_id) || {};
            this.local_client_id = client_id;
            this.local_blends = this.local_client?.data_blends || [];
        }
        this.reloadPagination(this.local_report_pages);
    },
    mounted() {
        // Set the default selected option after the component is mounted
        if (this.local_client_id) {
            // Find the selected client option
            this.selectedClientOption = this.clientOptions.find(option => option.value === this.local_client_id);
        } else {
            // Default to template reports
            this.selectedClientOption = this.clientOptions[0];
        }
        
        const tooltipTriggerList = document.querySelectorAll('[data-bs-toggle="tooltip"]');
        const tooltipList = [...tooltipTriggerList].map(tooltipTriggerEl => new window.bootstrap.Tooltip(tooltipTriggerEl));

        for (let i = 0; i < tooltipTriggerList.length; i++) {
            (function(index) {
                tooltipTriggerList[index].addEventListener('click', function() {
                    tooltipList[index].hide();
                });
                tooltipTriggerList[index].addEventListener('mouseleave', function() {
                    tooltipList[index].hide();
                });
            })(i);
        }
    },
    methods: {
        addFilter(dim) {
            dim.client_id = this.local_client_id;
            dim.data_blend_type = this.selected_blend.type;

            if (typeof dim.column === 'object') {
                dim.column = dim.column.value.toString();
            }

            window.axios.post('/api/metric_filter/deploy', dim)
                .then(response => {
                    const data = response.data || {};
                    const added = data.added_count ?? 0;
                    const skipped = data.skipped_count ?? 0;
                    let text = "A user-defined filter was deployed to " + this.selected_blend.type + " report pages.";
                    if (added > 0 && skipped > 0) {
                        text = "Filter added to " + added + " report page(s). " + skipped + " page(s) already had this filter and were skipped.";
                    } else if (added > 0) {
                        text = "Filter added to " + added + " report page(s).";
                    } else if (skipped > 0) {
                        text = "All " + skipped + " report page(s) already had this filter; nothing new was added.";
                    }
                    Swal.fire({
                        title: "Success!",
                        text,
                        icon: "success",
                        customClass: {
                            popup: 'swal-success'
                        },
                    });
                });

            const myModalEl = document.getElementById('dimension-filter-modal');
            const modal = bootstrap.Modal.getInstance(myModalEl);
            modal.hide();
        },
        getReportPageList() {
            let url = '/api/insights/page';
            if (this.local_client_id && this.local_client_id !== '') {
                url = '/api/insights/page/' + this.local_client_id;
            }

            window.axios.get(url)
                .then(response => {
                    this.local_report_pages = response.data.pages || [];
                    this.reloadPagination(this.local_report_pages);
                })
                .catch(error => {
                    console.error('Error fetching report pages:', error);
                    this.local_report_pages = [];
                    this.reloadPagination(this.local_report_pages);
                })
                .finally(() => {
                    this.isLoading = false;
                });
        },
        getDataBlendList() {
            this.local_blends = [];

            if (this.local_client_id != null && this.local_client_id !== "") {
                this.source_pages.forEach(report => {
                    if (!this.local_blends.some(blend => blend.id === report.data_blend.id)) {
                        this.local_blends.push(report.data_blend);
                    }
                });

                if(this.local_blends.length === 1) {
                    this.selected_blend = this.local_blends[0];
                }
            }
        },
        handleClientSelectionChange(selectedOption) {
            if (!selectedOption) {
                this.local_client_id = "";
                this.local_client = {};
            } else {
                this.local_client_id = selectedOption.value;
                this.local_client = Object.values(this.clients).find(c => c.id === selectedOption.value) || {};
            }
            
            let newURL;
            this.isLoading = true;
            
            if(this.local_client_id) {
                newURL = '/admin/report_builder/list/' + this.local_client.id;
            } else {
                newURL = '/admin/report_builder';
            }

            window.history.replaceState({}, {}, newURL);

            this.local_blends = this.local_client?.data_blends || [];
            this.getReportPageList();
        },
        navigateToReport(report_page) {
            window.location.href = '/insights/' + this.local_client.url + '/' + report_page.url;
        },
        sortByKey(key) {
            if (this.sort_key === key) {
                this.sort_order = (this.sort_order === 'asc') ? 'des' : 'asc';
            } else {
                this.sort_key = key;
                this.sort_order = 'asc';
            }
            this.sortData();
        },
        sortData() {
            if(this.sort_key === 'deployed_at') {
                if (this.sort_order === 'asc') {
                    this.local_report_pages.sort((a, b) => {
                        if (a.deployed_at && b.deployed_at) {
                            return a.deployed_at.localeCompare(b.deployed_at);
                        } else {
                            if (!a.deployed_at) return -1;
                            if (!b.deployed_at) return 1;
                        }
                    });
                } else {
                    this.local_report_pages.sort((a, b) => {
                        if (a.deployed_at && b.deployed_at) {
                            return b.deployed_at.localeCompare(a.deployed_at);
                        } else {
                            if (!a.deployed_at) return 1;
                            if (!b.deployed_at) return -1;
                        }
                    });
                }
            } else {
                if (this.sort_order === 'asc') {
                    this.local_report_pages.sort((a, b) => a[this.sort_key].localeCompare(b[this.sort_key]));
                } else {
                    this.local_report_pages.sort((a, b) => b[this.sort_key].localeCompare(a[this.sort_key]));
                }
            }
            this.reloadPagination(this.local_report_pages);
        },
        copyReport(report_page_id) {
            // Initialize the options array with the default option
            const options = ['*** Template Report ***'];

            // Convert this.clients into an array of {id, name} objects and add them to the options array
            Object.keys(this.clients).forEach(key => {
                options[key] = this.clients[key].name;
            });

            Swal.fire({
                title: "Copy this report?",
                text: "Please select the client to copy this report to.",
                input: "select",
                inputPlaceholder: "Select an organization",
                inputOptions: options,
                icon: "warning",
                showCancelButton: true,
                confirmButtonText: "Copy",
                customClass: {
                    popup: 'swal-warning'
                },
                inputValidator: (value) => {
                    return new Promise((resolve) => {
                        if (value) {
                            resolve();
                        } else {
                            resolve('You need to select a client');
                        }
                    });
                },
            }).then((result) => {
                if (result.isConfirmed) {
                    let client_id = -1;
                    //Find the client ID for the given selection
                    if(result.value > 0) {
                        client_id = this.clients[result.value].id;
                    }

                    const obj = {
                        client_id: client_id
                    };
                    window.axios.post('/api/insights/page/copy/' + report_page_id, obj)
                        .then(response => {
                            window.location = "/admin/report_builder/" + response.data.page.url;
                        });
                }
            });
        },
        deployTemplate(report_page_id) {
            var self = this;

            Swal.fire({
                title: "Are you sure you want to deploy this template?",
                text: "Doing this activate this template. If previously deployed, it will update the child reports to mirror the recent changes.",
                icon: "warning",
                showCancelButton: true,
                confirmButtonText: "Yes, deploy",
                customClass: {
                popup: 'swal-warning'
                },
            }).then((result) => {
                if (result.isConfirmed) {
                    window.axios.post('/api/insights/page/deploy/'+ report_page_id)
                        .then(response => {
                            // Refresh the report list to show updated status
                            this.getReportPageList();

                            Swal.fire({
                                title: "Success!",
                                text: response.data.message,
                                icon: "success",
                                customClass: {
                                popup: 'swal-success'
                                },
                            });
                        });
                }
            });
        },
        deleteReport(report_page_id) {
            var self = this;

            Swal.fire({
                title: "Are you sure you want to delete this report?",
                text: "This report will be removed.",
                icon: "warning",
                showCancelButton: true,
                confirmButtonText: "Yes, delete",
                customClass: {
                popup: 'swal-warning'
                },
            }).then((result) => {
                if (result.isConfirmed) {
                    window.axios.delete('/api/insights/page/'+ report_page_id).then(response => {
                        const reportName = this.local_report_pages.find(p => p.id === report_page_id)?.name || 'The report';
                        this.showNotification({
                            text: '<strong>' + reportName + '</strong> was successfully deleted!'
                        });
                        this.getReportPageList();
                    });
                }
            });
        },
    }
});
</script>

<style scoped>

.client-select {
    min-width: 350px;
}
.client-select :deep(.vs__dropdown-menu) {
    min-height: 400px !important;
}
</style>